import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [perms, setPerms] = useState(null);

  const loadPerms = async () => {
    try { const p = await api.get("/me/permissions"); setPerms(p.data); } catch {}
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch { return null; }
  };

  useEffect(() => {
    api.get("/auth/me")
      .then(async ({ data }) => {
        setUser(data);
        if (data?.role && data.role !== "supplier") await loadPerms();
      })
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.token) localStorage.setItem("triplus_token", data.token);
    setUser(data.user);
    if (data.user?.role && data.user.role !== "supplier") await loadPerms();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("triplus_token");
    setUser(false);
    setPerms(null);
  };

  const can = (collection, action) => {
    if (!user || user.role === "supplier") return false;
    if (!perms) return true; // optimistic until perms load; backend still enforces
    return perms.permissions?.[collection]?.[action] ?? false;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, perms, can, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
